import React, { useEffect, useState } from 'react';
import { Phone, PhoneOff, Mic, MicOff, PhoneOutgoing } from 'lucide-react';
import { Button } from '../../ui/Button';

const fmtDuration = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

/** What the call is doing, in a person's words. */
export const callStateLabel = (call, startedAt, now) =>
  call.state === 'calling' ? 'Calling…'
    : call.state === 'ringing' ? 'Ringing on WhatsApp…'
      : `${startedAt ? fmtDuration(now - startedAt) : '0:00'} · connected`;

/**
 * A CALL IN PROGRESS, WHEREVER THE OPERATOR IS. A call answered from the ringing card, or placed from
 * a chat, keeps going while they move around the back office — so its controls follow them, bottom
 * right, until it ends. (The Call Center page shows its own larger card instead.)
 */
export const ActiveCallBar = ({ callCenter, onOpen }) => {
  const { activeCall, callStartedAt, muted, hangUp, toggleMute } = callCenter;
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!activeCall) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [activeCall]);
  if (!activeCall) return null;
  const live = activeCall.state === 'connected';
  return (
    <div className="fixed bottom-5 right-5 z-[95] bg-white border border-[#BFE3CC] rounded-[12px] shadow-xl p-3 w-[320px]">
      <div className="flex items-center gap-3">
        <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 text-white ${live ? 'bg-[#1F6A3A]' : 'bg-[#6B7280]'}`}>
          {activeCall.outbound && !live ? <PhoneOutgoing className="w-4 h-4" /> : <Phone className="w-4 h-4" />}
        </div>
        <button type="button" onClick={onOpen} className="min-w-0 flex-1 text-left">
          <div className="text-[12.5px] font-semibold text-[#1F2937] truncate">{activeCall.contactName || activeCall.from}</div>
          <div className="text-[11px] text-[#6B7280] tabular-nums">{callStateLabel(activeCall, callStartedAt, now)}</div>
        </button>
      </div>
      <div className="flex items-center gap-2 mt-2.5">
        {live && <Button variant={muted ? 'primary' : 'secondary'} size="sm" icon={muted ? MicOff : Mic} onClick={toggleMute}>{muted ? 'Unmute' : 'Mute'}</Button>}
        <Button variant="danger" size="sm" icon={PhoneOff} onClick={hangUp} className="flex-1">{live ? 'End call' : 'Cancel'}</Button>
      </div>
    </div>
  );
};
